import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { colorBlack, colorWhite, subHeaderStyle, subHeaderStyleContrast } from "../../helper/style";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const LiqueAccordionControlled = ({ title, children, defaultExpanded = false, theme = "default", onChange = () => {} }) => {
  return (
    <Accordion
      expanded={defaultExpanded}
      onChange={onChange}
      sx={{ background: "transparent", boxShadow: "none", '& .MuiAccordionSummary-content': { marginTop: 0 } }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={theme === "default" ? { ...colorWhite } : {...colorBlack}} />}
        aria-controls="panel-detail-content"
        id="panel-detail-header"
        sx={{ paddingBottom: "5px" }}
      >
        <Typography variant="h4" sx={theme === "default" ? { ...subHeaderStyle } : { ...subHeaderStyleContrast }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ paddingY: "5px", paddingX: "20px" }}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default LiqueAccordionControlled;
